import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';

export const BUTTON_STATUS = {
  PENDING: 'PENDING',
  FULFILLED: 'FULFILLED',
  REJECTED: 'REJECTED',
  PRISTINE: 'PRISTINE',
  RETRY: 'RETRY',
} as const;
export type BUTTON_STATUS = (typeof BUTTON_STATUS)[keyof typeof BUTTON_STATUS];

export interface Props
  extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  leftIcon?: React.ReactElement;
  text?: string;
  rightIcon?: React.ReactElement;
  darkMode?: boolean;
  isSelected?: boolean;
  fetchStatus: BUTTON_STATUS;
  title: string;
  stayFulfilled?: boolean;
  errorTitle?: string;
  errorMessage?: string;
  secondary?: boolean;
  onBeforeSuccessAnimation?: () => void;
  onBeforeErrorAnimation?: () => void;
  onSuccess?: () => void;
  onError?: () => void;
}
